import React, { useState } from 'react';
import modalStyles from './DocumentMarcDisplayModal.module.scss';
import styles from '../helpDialog.module.scss';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Close } from '@material-ui/icons';
import GetAppIcon from '@material-ui/icons/GetApp';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import '../../styles/basic_style.scss';
import {
  DialogContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@material-ui/core';
import { saveAs } from 'file-saver';
import { marcToXml } from '../../utils/marc';

const SimpleDialogDemo = props => {
  // const options = { collapseContent: true, lineSeparator: '\n' };
  // const formattedXml = format(props.data2, options);

  const [open, setOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState('marc');

  // const guidsOnValue = props?.data1?.datafields?.reduce((acc, datafield) => {
  //   const guids = datafield?.subfields
  //     ?.filter(subfield => validateUuid(subfield?.value))
  //     ?.map(subfield => subfield?.value);

  //   return [...acc, ...guids];
  // }, []);

  // const { data: indexEntryData } = useQuery(GET_INDEX_ENTRIES, {
  //   variables: {
  //     where: {
  //       guid_in: guidsOnValue,
  //     },
  //     first: guidsOnValue.length,
  //   },
  //   skip: guidsOnValue?.length === 0,
  // });

  function handleClickOpen() {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  };

  const resolveValue = subfield => {
    // const indexEntries = indexEntryData?.simpleSearchIndexEntries;

    // const indexEntryForSubfield = indexEntries?.find(
    //   indexEntry => indexEntry.guid === subfield?.value
    // );

    // if (indexEntryForSubfield) {
    //   return indexEntryForSubfield.generatedDisplayName;
    // }

    const unitOfValuesJoined = (
      subfield?.value?.unitOfValues || subfield?.originalValue?.unitOfValues
    )
      .map(val => val.literalValue)
      .join('');

    const value =
      subfield?.value?.resolvedValue ||
      subfield?.value?.value ||
      subfield?.value;

    return unitOfValuesJoined && unitOfValuesJoined !== ''
      ? unitOfValuesJoined
      : value;
  };

  const reduceMarc21Json = () => {
    const marcJson = props.data1;

    const controlfields =
      marcJson?.controlfields?.map(controlfield => (
        <TableRow key={controlfield.tag}>
          <TableCell>{controlfield.tag}</TableCell>
          <TableCell align="right">{controlfield.value}</TableCell>
          <TableCell />
        </TableRow>
      )) ?? [];

    const datafields =
      marcJson?.datafields?.map(datafield => (
        <TableRow key={datafield.guid}>
          <TableCell>{datafield.tag}</TableCell>
          <TableCell align="right">
            {datafield.indicator1?.replace(' ', '#') ?? '#'}
            {datafield.indicator2?.replace(' ', '#') ?? '#'}
          </TableCell>
          <TableCell align="right">
            {datafield.subfields?.map(subfield => (
              <div key={subfield.guid}>
                <b>{subfield.code}</b>: {resolveValue(subfield)}
              </div>
            ))}
          </TableCell>
        </TableRow>
      )) ?? [];

    return [...controlfields, ...datafields];
  };

  const menuItems = [
    {
      key: 'marc',
      name: 'MARC',
      onClick: () => setSelectedMenu('marc'),
    },
    {
      key: 'marcXml',
      name: 'MARCXML',
      onClick: () => setSelectedMenu('marcXml'),
    },
  ];

  return (
    <div className="asdasd">
      <div onClick={handleClickOpen} className={styles.BookInfoDialogButton}>
        <span className={styles.bookInfoDialogButtonIcon}>
          <AssignmentOutlinedIcon />
        </span>
        <span className={styles.bookInfoDialogButtonText}>Marc</span>
      </div>

      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="md"
        className={styles.helpDialogBox}
        PaperProps={{ className: styles.helpPaperBlock }}
      >
        <DialogTitle
          className={modalStyles.headerContainer}
          disableTypography
          style={{ padding: 0 }}
        >
          <Grid container justifyContent="space-between">
            <Grid item>
              <Grid container>
                {menuItems.map(menuItem => (
                  <Grid
                    item
                    key={menuItem.key}
                    onClick={menuItem.onClick}
                    className={
                      selectedMenu === menuItem.key
                        ? [
                            modalStyles.menuItem,
                            modalStyles.activeMenuItem,
                          ].join(' ')
                        : modalStyles.menuItem
                    }
                  >
                    <Typography variant="h2">{menuItem.name}</Typography>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item>
              <Grid container>
                {selectedMenu === 'marcXml' && (
                  <Grid item>
                    <Button
                      color="primary"
                      endIcon={<GetAppIcon />}
                      style={{
                        height: '100%',
                        borderLeft: '1px solid gold',
                        borderRadius: 0,
                        paddingLeft: '20px',
                        paddingRight: '20px',
                      }}
                      onClick={() =>
                        saveAs(
                          new Blob([marcToXml(props.data1)], {
                            type: 'text/xml',
                          }),
                          'marcxml'
                        )
                      }
                    >
                      Letöltés
                    </Button>
                  </Grid>
                )}
                <Grid item>
                  <Button
                    className={modalStyles.closeButton}
                    onClick={handleClose}
                  >
                    <Close />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className={styles.helpDialogContent}>
          {selectedMenu === 'marc' ? (
            <TableContainer>
              <Table>
                <TableBody>{reduceMarc21Json()}</TableBody>
              </Table>
            </TableContainer>
          ) : (
            <code style={{ whiteSpace: 'pre-wrap' }}>
              {marcToXml(props.data1)}
            </code>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SimpleDialogDemo;
